import React from 'react';
import PropTypes from 'prop-types';
import { get } from 'lodash';
import numeral from 'numeral';
import { css } from '@bd/bdui-styles/emotion';
import { Image } from '@bd/bdcore-utilities';
import { Link } from '@bd/bdcore-named-routes';
import withData from '@bd/bdcore-data';
import { colors } from '../styles';

const styles = css`
  width: 100%;
  margin: 0 0 30px 0;
  .LotCard_wrapper {
    display: flex;
  }
  .LotCard_inner {
    width: 100%;
    display: flex;
    flex-direction: column;
    background-color: #FFFFFF;
  }
  .LotCard_media {
    img {
      width: 100%;
      height: auto;
    }
  }
  .LotCard_content {
    display: flex;
    flex-grow: 1;
    flex-direction: column;
    background-color: ${colors.color3Lightest};
    padding: 30px 20px 0 20px;
    h4 {
      margin: 0 0 5px 0;
      font-size: 20px;
      font-weight: 700;
      font-size: 20px;
      line-height: 22px;
      span {
        margin: 0 0 5px 0;
        font-size: 15px;
        font-weight: 300;
      }
      a {
        color: ${colors.color5};
        transition: all .3s ease;
        &:hover {
          color: ${colors.color2};
        }
      }
    }
  }
  .LotCard_priceWrapper {
    border-top: 1px solid ${colors.color3};
    border-bottom: 1px solid ${colors.color3};
    display: flex;
    width: 45%;
    background-color: ${colors.color3Light};
    align-items: center;
    justify-content: center;
  }
  .LotCard_priceValue {
    font-size: 19px;
    font-weight: 300;
    margin: 0;
  }
  .LotCard_textList {
    list-style: none;
    padding: 0;
    margin: 0;
    border-bottom: 1px solid ${colors.color3};
    flex-grow: 1;
    li {
      font-size: 13px;
      font-weight: 300;
      line-height: 1;
      border-top: 1px solid ${colors.color3};
      padding: 10px;
      a {
        color: ${colors.color2};
      }
    }
  }
  .LotCard_iconList {
    display: flex;
    list-style: none;
    margin: 0 0 15px 0;
    padding: 0;
    li {
      border-right: 1px solid ${colors.color3};
      width: 25%;
      text-align: center;
      padding: 12px 0;
      font-size: 14px;
      font-weight: 300;
      line-height: 18px;
      span {
        display: block;
      }
      &:last-child {
        border: 0;
      }
      .LotCard_iconListIcon {
        margin: 0 0 4px 0;
      }
      .LotCard_iconListValue {
        font-weight: 700;
      }
      a {
        color: ${colors.color2};
        font-weight: 700;
      }
      .LotCard_linkIcon {
        width: 13px;
        height: 13px;
        margin: 5px 0 0 0;
      }
    }
  }
  .LotCard_buttonWrapper {
    display: flex;
    justify-content: flex-end;
    margin: 0;
  }
  .LotCard_mapButton {
    width: 40px;
    height: 40px;
    background-color: #6C6C6C;
    background-image: url('/images/icon-map-pin-white.svg');
    background-position: center center;
    background-repeat: no-repeat;
  }
  .LotCard_detailButton {
    flex-grow: 1;
    height: 40px;
    line-height: 40px;
    text-align: center;
    background-color: ${colors.color2};
    color: #FFFFFF;
    font-weight: 700;
    font-size: 15px;
  }
`;

function LotCard({ community, home, plan }) {
  return (
    <div className={styles}>
      <div className="LotCard_wrapper">
        <div className="LotCard_inner">
          <div className="LotCard_media">
            <Link name="home-detail" home={home}>
              <Image
                src={get(home, 'photos[0].contentUrl')}
                alt={get(home, 'address.streetAddress')}
                width={475}
                height={315}
                exact
              />
            </Link>
          </div>
          <div className="LotCard_content">
            <h4>
              <Link name="home-detail" home={home}>
                {get(home, 'address.streetAddress')}<br />
                <span>{get(home, 'address.addressLocality')}, {get(home, 'address.addressRegion')} {get(home, 'address.postalCode')}</span>
              </Link>
            </h4>
            <div className="d-flex mt-2">
              <div className="LotCard_priceWrapper">
                <span className="LotCard_priceValue">{numeral(get(home, 'price')).format('$0,0')}</span>
              </div>
              <ul className="LotCard_textList">
                {
                  get(plan, 'name') &&
                  <li>Floor Plan: <Link name="plan-detail" plan={plan}>{get(plan, 'name')}</Link></li>
                }
                {
                  get(community, 'name') &&
                  <li>Community: <Link name="community-detail" community={community}>{get(community, 'name')}</Link></li>
                }
              </ul>
            </div>
            <ul className="LotCard_iconList">
              {
                get(home, 'beds') &&
                <li>
                  <span className="LotCard_iconListIcon"><img src="/images/icon-beds.svg" alt="" /></span>
                  <span className="LotCard_iconListValue">{get(home, 'beds')}</span>
                  <span className="LotCard_iconListLabel">Beds</span>
                </li>
              }
              {
                get(home, 'bathsFull') &&
                <li>
                  <span className="LotCard_iconListIcon"><img src="/images/icon-baths.svg" alt="" /></span>
                  <span className="LotCard_iconListValue">
                    {get(home, 'bathsFull')} {get(home, 'bathsHalf', 0) > 0 && '.5'}
                  </span>
                  <span className="LotCard_iconListLabel">Baths</span>
                </li>
              }
              {
                get(home, 'sqft') &&
                <li>
                  <span className="LotCard_iconListIcon"><img src="/images/icon-sqft.svg" alt="" /></span>
                  <span className="LotCard_iconListValue">{numeral(get(home, 'sqft')).format('0,0')}</span>
                  <span className="LotCard_iconListLabel">SQ FT</span>
                </li>
              }
              <li>
                <Link name="home-detail" home={home}>
                  View<br />Details<br />
                  <img src="/images/icon-arrow-gold.svg" className="LotCard_linkIcon" alt="" />
                </Link>
              </li>
            </ul>
            {/* <div className="LotCard_buttonWrapper">
              <Link className="LotCard_mapButton" />
              <Link className="LotCard_detailButton">Visit Community</Link>
            </div> */}
          </div>
        </div>
      </div>
    </div>
  );
}

LotCard.propTypes = {
  home: PropTypes.object.isRequired,
  plan: PropTypes.object,
  community: PropTypes.object,
};

LotCard.defaultProps = {
  plan: undefined,
  community: undefined,
};

export default withData(
  {
    home: true,
    plan: true,
    community: true,
  },
  {
    required: {
      home: true,
    },
  },
)(LotCard);



// WEBPACK FOOTER //
// ./src/components/LotCard.js